<ion-item class="input-field" lines="none" *transloco="let t">
  <ion-label position="stacked">{{ label }}</ion-label>
  <ion-input
    [type]="type"
    [value]="value"
    [disabled]="isDisabled"
    (input)="onInput($event.target.value)"
    [autocomplete]="autocomplete"
    [ngClass]="{
      icon: icon,
      error: (control && control.invalid && control.touched) || false
    }"
    [placeholder]="placeholder"
    (keydown)="handleKeyDown($event)"
  >
  </ion-input>
  <span
    *ngIf="(control && control.invalid && control.touched) || false"
    class="error"
    >{{ error ? error : t('common.required') }}</span
  >
  <ion-icon *ngIf="icon" [name]="icon"></ion-icon>
  <span
    *ngIf="!(control && control.invalid && control.touched)"
    [ngStyle]="{
      visibility:
        !(control && control.invalid && control.touched) && caption
          ? 'visible'
          : 'hidden'
    }"
    >{{ caption }}</span
  >
</ion-item>
